import { render, staticRenderFns } from "./study-mai.vue?vue&type=template&id=bb766fb6&scoped=true&"
import script from "./study-mai.vue?vue&type=script&lang=ts&"
export * from "./study-mai.vue?vue&type=script&lang=ts&"
import style0 from "./study-mai.vue?vue&type=style&index=0&id=bb766fb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb766fb6",
  null
  
)

export default component.exports